export default __webpack_public_path__ + "static/media/notification.1302f30d.svg";